// ============================================================================
// SAMPLE ENTITY ENDPOINTS (Reference Implementation)
// ============================================================================
// Endpoint definitions for Entity and Business Unit module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for entity endpoints
 */
const BASE_PATH = '/entities';

/**
 * Entity Endpoints
 */
export const sampleEntityEndpoints = {
  /**
   * Get all entities
   * GET /entities
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get entity by ID
   * GET /entities/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Create new entity
   * POST /entities
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update entity
   * PUT /entities/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete entity
   * DELETE /entities/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Search entities
   * POST /entities/search
   */
  search: () => buildEndpoint(`${BASE_PATH}/search`),

  /**
   * Get entities by type
   * GET /entities/by-type/:type
   */
  byType: (type: 'Entity' | 'Business Unit') =>
    buildEndpointWithParams(`${BASE_PATH}/by-type/:type`, { type }),

  /**
   * Get entity hierarchy
   * GET /entities/hierarchy
   */
  hierarchy: () => buildEndpoint(`${BASE_PATH}/hierarchy`),

  /**
   * Get entity children
   * GET /entities/:id/children
   */
  children: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/children`, { id }),

  /**
   * Get entity statistics
   * GET /entities/:id/statistics
   */
  statistics: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/statistics`, { id }),

  /**
   * Get active entities
   * GET /entities/active
   */
  active: () => buildEndpoint(`${BASE_PATH}/active`),

  /**
   * Bulk delete entities
   * DELETE /entities/bulk
   */
  bulkDelete: () => buildEndpoint(`${BASE_PATH}/bulk`),

  /**
   * Export entities
   * GET /entities/export
   */
  export: () => buildEndpoint(`${BASE_PATH}/export`),

  /**
   * Import entities
   * POST /entities/import
   */
  import: () => buildEndpoint(`${BASE_PATH}/import`),
} as const;

/**
 * Export endpoints
 */
export default sampleEntityEndpoints;
